import React, { useState } from "react";
import { BookingWidgetProps } from "./types";
import FlightSearchForm from "./FlightSearchForm";

const BookingWidget: React.FC<BookingWidgetProps> = ({
    searchState,
    onSearchStateChange,
    onSearch,
}) => {
    const [activeTab, setActiveTab] = useState("book-flight");

    return (
        <div
            className="relative z-20 lg:-mt-32 landscape:-mt-32 mx-auto lg:px-0 landscape:px-0"
            style={{ maxWidth: "1152px" }}
        >
            {/* Desktop Tabs - Show on desktop and landscape mobile */}
            <div
                className="hidden lg:flex portrait:hidden landscape:flex mx-auto"
                style={{ maxWidth: "864px" }}
            >
                <button
                    onClick={() => setActiveTab("book-flight")}
                    className={`flex-1 py-3 px-6 text-center font-base text-[17px] ${
                        activeTab === "book-flight"
                            ? "text-white rounded-t-2xl relative z-10"
                            : "bg-white text-gray-700 -ml-4 pl-10 border-b border-gray-300 shadow-sm"
                    }`}
                    style={
                        activeTab === "book-flight"
                            ? { backgroundColor: "#0047ba" }
                            : {}
                    }
                >
                    Book a flight
                </button>
                <button
                    onClick={() => setActiveTab("manage-booking")}
                    className={`flex-1 py-3 px-6 text-center font-base text-[17px] ${
                        activeTab === "manage-booking"
                            ? "text-white rounded-t-2xl relative z-10"
                            : "bg-white text-gray-700 -ml-4 pl-10 border-b border-gray-300 shadow-sm"
                    }`}
                    style={
                        activeTab === "manage-booking"
                            ? { backgroundColor: "#0047ba" }
                            : {}
                    }
                >
                    Manage booking
                </button>
                <button
                    onClick={() => setActiveTab("check-in")}
                    className={`flex-1 py-3 px-6 text-center font-base text-[17px] ${
                        activeTab === "check-in"
                            ? "text-white rounded-t-2xl relative z-10"
                            : "bg-white text-gray-700 border-b border-gray-300 shadow-sm"
                    }`}
                    style={
                        activeTab === "check-in"
                            ? { backgroundColor: "#0047ba" }
                            : {}
                    }
                >
                    Check-in
                </button>
                <button
                    onClick={() => setActiveTab("flight-status")}
                    className={`flex-1 py-3 px-6 text-center font-base text-[17px] ${
                        activeTab === "flight-status"
                            ? "text-white rounded-t-2xl relative z-10"
                            : "bg-white text-gray-700 rounded-tr-2xl border-b border-gray-300 shadow-sm"
                    }`}
                    style={
                        activeTab === "flight-status"
                            ? { backgroundColor: "#0047ba" }
                            : {}
                    }
                >
                    Flight status
                </button>
            </div>

            {/* Content Card */}
            <div className="bg-white lg:rounded-2xl lg:shadow-2xl landscape:rounded-2xl landscape:shadow-2xl">
                {activeTab === "book-flight" && (
                    <FlightSearchForm
                        searchState={searchState}
                        onSearchStateChange={onSearchStateChange}
                        onSearch={onSearch}
                    />
                )}

                {activeTab === "manage-booking" && (
                    <div className="px-8 py-6">
                        <p className="text-gray-600">Manage booking content</p>
                    </div>
                )}

                {activeTab === "check-in" && (
                    <div className="px-8 py-6">
                        <p className="text-gray-600">Check-in content</p>
                    </div>
                )}

                {activeTab === "flight-status" && (
                    <div className="px-8 py-6">
                        <p className="text-gray-600">Flight status content</p>
                    </div>
                )}
            </div>

            {/* Mobile Tabs - Show only on mobile portrait, below content */}
            <div className="lg:hidden landscape:hidden bg-white shadow-2xl rounded-2xl mx-6 my-2">
                <div className="grid grid-cols-3">
                    <button
                        onClick={() => setActiveTab("manage-booking")}
                        className="flex flex-col items-center justify-center py-4 border-r border-gray-200"
                    >
                        <svg
                            className="w-6 h-6 mb-1 text-gray-700"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                            />
                        </svg>
                        <span className="text-xs text-gray-700">Manage</span>
                        <span className="text-xs text-gray-700">booking</span>
                    </button>
                    <button
                        onClick={() => setActiveTab("check-in")}
                        className="flex flex-col items-center justify-center py-4 border-r border-gray-200"
                    >
                        <svg
                            className="w-6 h-6 mb-1 text-gray-700"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>
                        <span className="text-xs text-gray-700">Check-in</span>
                    </button>
                    <button
                        onClick={() => setActiveTab("flight-status")}
                        className="flex flex-col items-center justify-center py-4"
                    >
                        <svg
                            className="w-6 h-6 mb-1 text-gray-700"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                            />
                        </svg>
                        <span className="text-xs text-gray-700">
                            Flight status
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BookingWidget;
